import React from 'react';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import { useLanguage } from '../../i18n/LanguageContext';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="footer text-center">
      <div className="container">
        <div className="social-links mb-3">
          <a
            href="https://github.com/ZeeshanAhmedDev"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
          >
            <FaGithub />
          </a>
          <a
            href="https://www.linkedin.com/in/zeeshaanahmed/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </a>

          <a
            href="mailto:contact@zeeshaanahmed.qzz.io"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Email"
          >
            <FaEnvelope />
          </a>
        </div>
        <p className="small mb-0">
          &copy;{new Date().getFullYear()} Zeeshan Ahmed - {t('footer.rights')}
        </p>
      </div>
    </footer>
  );
}
